import { OperationId, operations } from '../operations';
import { AssetsSimplificationOperation } from './form/sections/assetSimplification/AssetsSimplificationOperation';
import { CompressionAndExportOperation } from './form/sections/compressionAndExport/CompressionAndExportOperation';
import { LimitsOperation } from './form/sections/limits/LimitsOperation';
import { SceneManipulationOperation } from './form/sections/sceneManipulation/SceneManipulationOperation';
import { TargetsOperation } from './form/sections/targets/TargetsOperation';
import { UvUnwrappingOperation } from '@/app/workflows/components/v6/operations/settings/form/sections/uvUnwrapping/UvUnwrappingOperation';
import { Workflow } from '@/app/workflows/actions/interfaces';
import { Fieldset } from '@mantine/core';

type SettingsRouterProps = {
  id: (typeof operations)[number]['id'] | null;
  workflow: Workflow;
};

export function SettingsRouter({ id, workflow }: SettingsRouterProps) {
  const isEnabled = isOperationEnabled(workflow, id);

  if (!id) {
    return null;
  }

  const Operation = getOperation(id);

  return (
    <Fieldset
      disabled={!isEnabled}
      w='100%'
      style={(theme) => ({
        border: 'none',
        borderLeft: `1px solid ${theme.colors.gray[3]}`,
        overflow: 'auto',
      })}
      pl='md'
      h='752px'
    >
      {Operation}
    </Fieldset>
  );
}

function getOperation(id: OperationId) {
  switch (id) {
    case 'uvUnwrapping':
      return <UvUnwrappingOperation />;
    case 'limits':
      return <LimitsOperation />;
    case 'targets':
      return <TargetsOperation />;
    case 'assetSimplification':
      return <AssetsSimplificationOperation />;
    case 'compressionAndExport':
      return <CompressionAndExportOperation />;
    case 'sceneManipulation':
      return <SceneManipulationOperation />;
    default:
      return null;
  }
}

function isOperationEnabled(workflow: Workflow | undefined, operationId: OperationId | null) {
  if (!operationId) {
    return false;
  }

  return workflow?.clientMetadata?.enabledOperations?.includes(operationId) ?? false;
}
